<template>
  <div class="indexActivity">
    <div class="search">
      <div class="searchItem">
        <p>展览名称：</p>
        <el-input v-model="name" placeholder="请输入内容" clearable></el-input>
      </div>
      <button @click="search">
        <i class="el-icon-search"></i>
        <p>搜索</p>
      </button>
    </div>
    <div class="activityContent">
      <div
        v-for="(hall, index) in this.hallSearch"
        :key="index"
        class="activityItem"
        @click="toDetial(hall.id)"
      >
        <div>
          <img :src="hall.titleImg" />
          <button class="yes">
            <i class="el-icon-timer"></i>
            <span>预</span>
            <span>约</span>
          </button>
          <!-- <template v-if="hall.typeName !='常规展'">
            <div v-if="isStarted(hall.seTime)">
              <p>当天可预约：</p>
              <p>{{hall.residueMake}}</p>
            </div>
            <div v-if="!isStarted(hall.seTime)">
              <p>未开展</p>
              <p></p>
            </div>
          </template>-->
        </div>
        <div>
          <div>{{ hall.name }}</div>
          <template v-if="hall.typeName == '临时展'">
            <p>时间：{{ hall.seTime }}</p>
          </template>
          <template v-else>
            <p>
              类型：
              <span class="tag-wrap">常规展</span>
            </p>
          </template>
          <p>地点：{{ hall.areaAddress }}</p>
          <div>
            <p>简介：</p>
            <p>{{ hall.remark }}</p>
          </div>
        </div>
      </div>
      <div class="nothing wait" v-if="halls == 'undefind' && halls.length < 1">
        <img src="../../assets/images/timg.jpg" />
        <span>暂时无展览活动哦~ 请过几天再预约啦~</span>
      </div>
      <div class="loading wait" v-if="loading">
        <img src="../../assets/images/loading.gif" />
        <span>找找展览活动在哪里~</span>
      </div>
    </div>
  </div>
</template>
<script>
import { findAllExhibitMakeSchId } from "@/libs/api";
import Moment from "moment";
export default {
  data() {
    return {
      loading: true,
      nothing: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      active: 1,
      halls: [],
      hallSearch: [],
      name: "",
      time: ""
    };
  },
  methods: {
    isStarted: function(time) {
      time = time.split("~")[0];
      return new Moment().isAfter(time);
    },
    //格式化日期
    formatTime(date) {
      const year = date.getFullYear();
      const month =
        date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      const hour = date.getHours();
      return `${year}-${month}-${day}`;
    },
    search: function() {
      this.hallSearch = this.halls.filter((item, index) => {
        console.log(item);
        if (this.name == "") {
          return true;
        } else if (this.name != "") {
          return item.name.indexOf(this.name) > -1;
        }
      });
    },
    getHalls: function() {
      findAllExhibitMakeSchId(this.formatTime(new Date()), this.$route.query.id).then(data => {
        // console.log(data.data);
        if (data.status) {
          this.halls = data.data;
          this.hallSearch = this.halls;
        } else {
          this.nothing = true;
          this.$alert("展厅获取失败。请稍后再试", "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
        }
        this.loading = false;
      });
    },
    toDetial: function(hallId) {
      this.$router.push({ path: "activityDetial", query: { id: hallId } });
    }
  },
  beforeMount() {
    this.getHalls();
  }
};
</script>
<style lang="less" scoped>
.indexActivity {
  .search {
    height: 6vh;
    display: flex;
    background-color: #1a1a1a;
    color: white;
    justify-content: flex-end;
    font-size: 16px;
    align-items: center;
    border-radius: 5px;
    input {
      height: 35px;
    }
    .searchItem {
      width: 30%;
      display: flex;
      align-items: center;
      p {
        text-align: right;
        box-sizing: border-box;
      }
      .el-input {
        width: 80%;
        .el-input__inner {
          height: 30px;
        }
      }
    }
    input {
      height: 55%;
      background-color: #1a1a1a;
      border: 1px solid #ccc;
      outline: none;
      color: white;
      padding-left: 10px;
      box-sizing: border-box;
    }
    .time {
      margin-left: 4%;
    }
    button {
      width: 6%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 59%;
      background-color: #ae0c2a;
      border: 1px solid #ae0c2a;
      color: white;
      margin-left: 1%;
      margin-right: 1%;
      outline: none;
      border-radius: 5px;
      i {
        margin-right: 6px;
        font-size: 16px;
      }
    }
  }
  .activityContent {
    height: 70vh;
    margin-top: 2vh;
    overflow-y: scroll;
    padding-right: 2px;
    .wait {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      letter-spacing: 2px;
      background-color: white;
      border-radius: 5px;
      //background-image: url("~@/assets/images/registerbg.jpg");
      //background-repeat: no-repeat;
      //background-position: bottom;
      //background-color: #f1eee7;
      i {
        font-size: 40px;
        color: white;
        margin-top: 20vh;
        margin-bottom: 20px;
      }
      span {
        font-size: 24px;
        color: #c1c1c1;
      }
      img {
        width: 20%;
        margin-top: 11vh;
        margin-bottom: 3vh;
      }
    }
    @media screen and (min-width: 1241px) and (max-width: 1400px) {
      .activityItem {
        height: 29vh !important;
      }
    }
    .activityItem {
      border: 1px solid rgba(0, 0, 0, 0);
      background-color: #1a1a1aa6;
      width: 32%;
      display: flex;
      box-sizing: border-box;
      color: white;
      padding: 15px;
      align-items: flex-start;
      margin-bottom: 2.5vh;
      margin-right: 1%;
      float: left;
      height: 21vh;
      cursor: pointer;
      > div:first-child {
        width: 40%;
        display: flex;
        flex-flow: wrap;
        img {
          width: 170px;
          height: 112px;
          margin-bottom: 0.85vh;
        }
        button {
          background-color: #ae0c2a;
          color: white;
          border: none;
          width: 170px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          border-radius: 10px;
          font-size: 18px;
          border: 1px solid #ae0c2a;
          span:nth-of-type(2) {
            margin-top: 2.5px;
            margin-left: 2px;
          }
          .el-icon-timer {
            margin-right: 3px;
            font-size: 25px;
          }
        }
        .no {
          background-color: #ccc;
          border: 1px solid #ccc;
          color: white;
        }
        div {
          display: flex;
          justify-content: flex-end;
          flex: 1;
          align-items: flex-end;
          p:first-child {
            font-size: 12px;
          }
          p:last-child {
            font-size: 20px;
            line-height: 1;
          }
        }
      }
      > div:last-child {
        flex: 1;
        margin-left: 3%;
        p {
          font-size: 12px;
          margin-bottom: 0.5vh;
        }
        > div:first-child {
          font-size: 25px;
          line-height: 1;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
          margin-bottom: 10px;
          word-break: break-all;
        }
        div {
          display: flex;
          font-size: 12px;
          p:last-child {
            color: #8b8b8b;
            flex: 1;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            line-clamp: 5;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    .activityItem:hover {
      background: rgba(231, 7, 7, 0.24);
      // border: 1px solid red;
    }
  }
}
</style>
<style scoped>
.activityContent::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}
.activityContent::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}
.activityContent::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}
.activityContent::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}
.activityContent::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}
.activityContent::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}
.activityContent::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}
.activityContent {
  scrollbar-arrow-color: #f4ae21; /**/ /*三角箭头的颜色*/
  scrollbar-face-color: #333; /**/ /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666; /**/ /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666; /**/ /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999; /**/ /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666; /**/ /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666; /**/ /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8; /**/ /*滚动条的基本颜色*/
}
.searchItem .el-input .el-input__inner {
  height: 35px;
}
.tag-wrap {
  color: rgb(174, 12, 42);
  border: 1px solid rgb(174, 12, 42);
  padding: 1px 3px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/single/activity.vue